import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const isFirstFloorTagManager = createBooleanTagManager({
  jsonQueryKey: 'is_first_floor',
  trueLabel: 'Первый этаж',
  falseLabel: 'Не первый этаж',
  id: 'isFirstFloor',
});
